export default __webpack_public_path__ + "static/media/image-banner.983c9d82.png";